import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const Root = styled.div.withConfig({
  displayName: "DropdownMenuTitle__Root",
  componentId: "sc-17pluo7-0"
})(["", " text-transform:uppercase;color:var(--neutral-text-low-emphasis);font:var(--text-xs-bold);padding:var(--size-spacing-02) var(--size-spacing-04);"], ScopedCssBaseline);
const DropdownMenuTitle = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Root, _extends({
  ref: ref
}, props)));
DropdownMenuTitle.displayName = 'DropdownMenu.Title';
DropdownMenuTitle.defaultProps = {
  children: null
};
DropdownMenuTitle.propTypes = {
  /**
   * Sets the children element
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node])
};
export default DropdownMenuTitle;